
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const CheckCircleIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M69.9757 37.9788C71.3426 36.612 71.3426 34.3959 69.9758 33.0291C68.609 31.6622 66.3929 31.6622 65.026 33.029L42.5001 55.5543L31.9749 45.0291C30.608 43.6623 28.3919 43.6623 27.0251 45.0291C25.6583 46.396 25.6583 48.6121 27.0251 49.9789L40.0252 62.9789C41.392 64.3457 43.6081 64.3457 44.9749 62.9789L69.9757 37.9788Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8ZM15 48C15 29.7746 29.7746 15 48 15C66.2254 15 81 29.7746 81 48C81 66.2254 66.2254 81 48 81C29.7746 81 15 66.2254 15 48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M69.9757 37.9788C71.3426 36.612 71.3426 34.3959 69.9758 33.0291C68.609 31.6622 66.3929 31.6622 65.026 33.029L42.5001 55.5543L31.9749 45.0291C30.608 43.6623 28.3919 43.6623 27.0251 45.0291C25.6583 46.396 25.6583 48.6121 27.0251 49.9789L40.0252 62.9789C41.392 64.3457 43.6081 64.3457 44.9749 62.9789L69.9757 37.9788Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8ZM15 48C15 29.7746 29.7746 15 48 15C66.2254 15 81 29.7746 81 48C81 66.2254 66.2254 81 48 81C29.7746 81 15 66.2254 15 48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
